export default __webpack_public_path__ + "static/micro-23f0be960366a958a4d3245cd17866a4.mp4";